module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "TopicsTopEntrance"
  }, [_c('div', {
    staticClass: "TopicsTopEntrance-header"
  }, [_c('div', [_vm._v("跑区管理")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增跑区")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "跑区名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉及围栏",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_vm._v(_vm._s(_vm.row.fenceName && _vm.row.fenceName.length && _vm.row.fenceName.join(',')))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_vm._v(_vm._s(new Date(_vm.row.updateAt).format('yyyy-MM-dd')))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200px",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return [_c('el-button', {
            attrs: {
              "type": "primary",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDetail(_vm.row)
              }
            }
          }, [_vm._v("\n                    跑区信息\n                ")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "primary",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.row)
              }
            }
          }, [_vm._v("\n                    删除\n                ")])]
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc73ec60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/runarea/index.vue
// module id = 1128
// module chunks = 0